// import React, { Component } from "react";
// import Avatar from "@material-ui/core/Avatar";
// import CommentBox from "./CommentBox";
// import MediaList from "./MediaList";
// // import DisplayDate from "../DisplayDate/index";
// import Button from "@material-ui/core/Button";
// import Card from "@material-ui/core/Card";
// import { Input } from "reactstrap";
// import { ArrowRightSquareFill, PlayFill, Trash } from "react-bootstrap-icons";
// import DeleteIcon from "@material-ui/icons/Delete";
// import EditIcon from "@material-ui/icons/Edit";
// import moment from "moment";
// import { history } from "../../../store/index";
// import { httpClient } from "appUtility/Api";
// import IconButton from "@material-ui/core/IconButton";
// import AlertDialog from "./AlertDialog";
// import {
//   NotificationManager,
//   NotificationContainer,
// } from "react-notifications";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import EditPostItem from "./EditPostItem";
// import CommentContext from "./CommentContext";
// import { Box, Tooltip } from "@material-ui/core";
// import parse from "html-react-parser";
// import featureServer from "./../../../appUtility/featureServer";
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
// import GroupDetail from "../../../app/routes/socialApps/routes/Profile/groupDetail";

// const qs = require("qs");
// const socialData = JSON.parse(window.localStorage.getItem("login"));

// class PostItem extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       message: "",
//       totalComments: "",
//       totalLikes: "",
//       isLiked: null,
//       likeLoader: false,
//       deleteAlert: false,
//       user: {
//         name: socialData && socialData.fname + "" + socialData.lname,
//         userID: socialData && socialData.uid,
//         image: socialData && socialData.img,
//       },
//       post: {},
//       userProfile: "",
//       showComments: false,
//       commentList: [],
//       commentLoader: false,
//       commentPostLoader: false,
//       singleData: [],
//       single: false,
//       showCarousel: false,
//       open: false,
//       commentImage: [],
//       openEtiquette: false,
//       groupID1: "",
//       groupName1: "",
//     };
//     this.commentImageRef = React.createRef();
//   }

//   componentWillMount() {
//     this.setState({
//       post: this.props.postData,
//       totalComments: this.props.postData.totalComments,
//       totalLikes: this.props.postData.totalLikes,
//       userProfile: this.props.userProfile,
//       isLiked: this.props.postData.isLiked,
//     });
//   }

//   filterDeletedComment = (id) => {
//     let filteredComment = this.state.commentList.filter(
//       (item) => item.commentID !== id
//     );
//     this.setState({ ...this.state, commentList: filteredComment });
//   };

//   RequestDeletePost = () => {
//     this.setState({ ...this.state, deleteAlert: true });
//   };

//   CancelDeletePost = () => {
//     this.setState({ ...this.state, deleteAlert: false });
//   };

//   handleNewComment = (e) => {
//     let comData = new FormData();
//     // if (e.key === "Enter") {
//     this.setState({
//       ...this.state,
//       commentLoader: true,
//       commentPostLoader: true,
//     });
//     // console.log('state in comment', this.state);
//     comData.append("userID", socialData && socialData.uid);
//     comData.append("userCode", socialData && socialData.memtoken);
//     comData.append("appID", socialData && socialData.aid);
//     comData.append("companyID", socialData && socialData.cid);
//     comData.append("commentText", this.state.message);
//     comData.append("postID", this.state.post.postID);
//     this.state.commentImage.forEach((img) =>
//       comData.append("mediaList[]", img)
//     );
//     comData.append("action", "comments_save");
//     comData.append("imageHeight", 600);
//     comData.append("imageWidth", 600);

//     // const newCommentData = {
//     //   userID: socialData && socialData.uid,
//     //   userCode: socialData && socialData.memtoken,
//     //   appID: 1,
//     //   companyID: socialData && socialData.cid,
//     //   commentText: this.state.message,
//     //   postID: this.state.post.postID,
//     // };

//     // featureServer ?
//     httpClient
//       .post("api/social/posts_comments_save.php", comData)
//       .then((res) => {
//         if (res.data.msg !== "Commented Successfully") {
//           this.setState({
//             ...this.state,
//             commentLoader: false,
//             commentPostLoader: false,
//           });
//           NotificationManager.warning(res.data.msg);
//           this.getAllComments();
//         } else {
//             console.log("comment test triggered")
//             NotificationManager.success(res.data.msg);
//           this.setState({
//             ...this.state,
//             message: "",
//             totalComments: res.data.totalComments,
//             commentPostLoader: false,
//           });

//           if (!this.state.showComments) {
//             this.setState({ ...this.state, showComments: true });
//           }
//           //------Concatinating the latest comment into the commentList Array------//
//           let latestComment = {
//             // commentUserImage: socialData && socialData.img,
//             commentUserName:
//               socialData && socialData.fname + "" + socialData.lname,
//             commentText: res && res.data && res.data.commenttext,
//             commentID: res && res.data && res.data.commentID.toString(),
//             postID: res && res.data && res.data.postID,
//             commentUserID: res && res.data && res.data.userID,
//             commentedDate: moment(),
//             totalComments: "0",
//             userThumbnail: res && res.data && res.data.userThumbnail,
//           };

//           if (this.state.commentList.length === 0) {
//             this.getAllComments();
//           } else {
//             let updatedCommentList = this.state.commentList.concat([
//               latestComment,
//             ]);
//             this.setState({
//               ...this.state,
//               commentList: updatedCommentList,
//               commentLoader: false,
//               commentPostLoader: false,
//               totalComments: res && res.data && res.data.totalComments,
//             });
//             this.getAllComments();
//           }
//           //----------------**********--------------------//
//           this.setState({ commentImage: [] });
//           if (this.commentImageRef.current) {
//             this.commentImageRef.current.value = ""; // Clear the file input
//           }
//         }
//       });
//     //   :
//     // httpClient
//     //   .post(
//     //     "api/social/posts_comments_save.php",
//     //     qs.stringify({
//     //       action: "comments_save",
//     //       source: newCommentData,
//     //     })
//     //   )
//     //   .then((res) => {
//     //     console.log("comment dataaaaaaa", res.data);

//     //     if (res.data.msg !== "Commented Successfully") {
//     //       this.setState({ ...this.state, commentLoader: false });
//     //       NotificationManager.warning(res.data.msg);
//     //       this.getAllComments();
//     //     } else {
//     //       this.setState({
//     //         ...this.state,
//     //         message: "",
//     //         totalComments: res.data.totalComments,
//     //       });

//     //       if (!this.state.showComments) {
//     //         this.setState({ ...this.state, showComments: true });
//     //       }
//     //       //------Concatinating the latest comment into the commentList Array------//
//     //       let latestComment = {
//     //         // commentUserImage: socialData && socialData.img,
//     //         commentUserName:
//     //           socialData && socialData.fname + "" + socialData.lname,
//     //         commentText: res && res.data && res.data.commenttext,
//     //         commentID: res && res.data && res.data.commentID.toString(),
//     //         postID: res && res.data && res.data.postID,
//     //         commentUserID: res && res.data && res.data.userID,
//     //         commentedDate: moment(),
//     //         totalComments: "0",
//     //         userThumbnail: res && res.data && res.data.userThumbnail,
//     //       };

//     //       if (this.state.commentList.length === 0) {
//     //         this.getAllComments();
//     //       } else {
//     //         let updatedCommentList = this.state.commentList.concat([
//     //           latestComment,
//     //         ]);
//     //         this.setState({
//     //           ...this.state,
//     //           commentList: updatedCommentList,
//     //           commentLoader: false,
//     //           totalComments: res && res.data && res.data.totalComments,
//     //         });
//     //         this.getAllComments();
//     //       }
//     //       //----------------**********--------------------//
//     //     }
//     //   });
//     // }
//   };

//   handleCommentRemove = (commentID, postID) => {
//     const deleteQuery = {
//       userID: socialData && socialData.uid,
//       userCode: socialData && socialData.memtoken,
//       appID: socialData && socialData.aid,
//       companyID: socialData && socialData.cid,
//       postID: postID,
//       commentID: commentID,
//       parentCommentID: 0,
//     };

//     httpClient
//       .post(
//         "api/social/posts_comments_save.php",
//         qs.stringify({
//           action: "comments_delete",
//           source: deleteQuery,
//           // userID: socialData && socialData.uid,
//           // userCode: socialData && socialData.memtoken,
//           // appID: 1,
//           // companyID: socialData && socialData.cid,
//           // postID: postID,
//           // commentID: commentID,
//         })
//       )
//       .then((res) => {
//         if (res.data.success !== "true") {
//           NotificationManager.warning(res.data.msg);
//         } else {
//           // console.log('comment deleter response', res.data);
//           NotificationManager.success(res.data.msg);
//           this.setState({
//             totalComments: res.data && res.data.totalComments,
//           });
//           this.filterDeletedComment(res.data.commentID);
//         }
//       });
//   };

//   updateCommentValue(evt) {
//     this.setState({ ...this.state, message: evt.target.value });
//   }

//   updateCommentValueEditor(value) {
//     this.setState({ ...this.state, message: value });
//   }

//   handleLikeToggle() {
//     this.setState({
//       likeLoader: true,
//     });
//     if (
//       this.state.isLiked === "0" ||
//       this.state.isLiked === 0 ||
//       this.state.isLiked === undefined
//     ) {
//       const likeData = {
//         userID: socialData && socialData.uid,
//         userCode: socialData && socialData.memtoken,
//         appID: socialData && socialData.aid,
//         companyID: socialData && socialData.cid,
//         postID: this.state.post.postID,
//       };

//       httpClient
//         .post(
//           "api/social/likes_save.php",
//           qs.stringify({
//             action: "likes_save",
//             source: likeData,
//           })
//         )
//         .then((res) => {
//           if (res.data.success === "true") {
//             this.setState({
//               ...this.state,
//               totalLikes: res.data.total++,
//               isLiked: 1,
//               likeLoader: false,
//             });
//           } else {
//             NotificationManager.warning(res.data.msg);
//           }
//         });
//     } else {
//       const likeData = {
//         userID: socialData && socialData.uid,
//         userCode: socialData && socialData.memtoken,
//         appID: socialData && socialData.aid,
//         companyID: socialData && socialData.cid,
//         postID: this.state.post.postID,
//       };

//       httpClient
//         .post(
//           "api/social/likes_save.php",
//           qs.stringify({
//             action: "likes_remove",
//             source: likeData,
//           })
//         )
//         .then((res) => {
//           if (res.data.success === "true") {
//             this.setState({
//               ...this.state,
//               totalLikes: res.data.total--,
//               isLiked: 0,
//               likeLoader: false,
//             });
//           } else {
//             NotificationManager.warning(res.data.msg);
//           }
//         });
//     }
//   }

//   getAllComments = (total) => {
//     this.setState({
//       ...this.state,
//       showComments: true,
//       commentList: [],
//       commentLoader: true,
//     });

//     const getCommentsQuery = {
//       userID: socialData && socialData.uid,
//       userCode: socialData && socialData.memtoken,
//       appID: socialData && socialData.aid,
//       companyID: socialData && socialData.cid,
//       postID: this.state.post.postID,
//     };

//     httpClient
//       .post(
//         "api/social/posts_comments_get.php",
//         qs.stringify({
//           action: "posts_comments",
//           source: getCommentsQuery,
//         })
//       )
//       .then((res) => {
//         if (res.data.data === null) {
//           console.log("No comments for this post !");
//           this.setState({ ...this.state, commentLoader: false });
//         } else {
//           total !== undefined
//             ? this.setState({
//               ...this.state,
//               commentList: res.data.data,
//               commentLoader: false,
//               totalComments: total,
//               showComments: true,
//             })
//             : this.setState({
//               ...this.setState,
//               commentList: res.data.data,
//               commentLoader: false,
//             });
//         }
//       });
//   };

//   seeAllComments = () => {
//     if (this.state.commentList.length > 0) {
//       this.setState({ ...this.state, showComments: !this.state.showComments });
//     } else if (this.props.postData.totalComments === "0") {
//       this.setState({ ...this.state, showComments: !this.state.showComments });
//     } else if (this.props.postData.totalComments !== "0") {
//       this.getAllComments();
//     } else {
//       return;
//     }
//   };

//   RequestEditPostOpen = () => {
//     this.setState({
//       open: true,
//     });
//   };

//   RequestEditPostClose = (callback) => {
//     // console.log('edit post callback', callback);
//     this.setState({
//       open: false,
//     });
//   };

//   editPost = (postTitle, imageList) => {
//     // console.log('edit post >>', this.state.post);
//     // console.log(postTitle, imageList, 'edit');
//     let fd = new FormData();
//     fd.append("userID", socialData && socialData.uid);
//     fd.append("userCode", socialData && socialData.memtoken);
//     fd.append("appID", socialData && socialData.aid);
//     fd.append("companyID", socialData && socialData.cid);
//     fd.append("postText", postTitle);
//     fd.append("postID", this.state.post.postID);
//     fd.append("groupID", this.state.post.groupID != null ? this.state.post.groupID : 0);
//     fd.append("type", "post_save");
//     fd.append("imageHeight", 600);
//     fd.append("imageWidth", 600);

//     // imageList.forEach((data) => fd.append("mediaList[]", data));

//     httpClient.post("api/social/posts_save.php", fd).then((res) => {
//       if (res.data.success === "false") {
//         NotificationManager.warning(res.data.msg);
//       } else {
//         NotificationManager.success(res.data.msg);
//         this.RequestEditPostClose();
//         setTimeout(() => {
//           history.push(`/app/social/profileDetail`);
//         }, 3000)
//       }
//     });
//   };

//   handleDeletePost = (postID, groupID) => {
//     let groupIDCheck;

//     if (groupID === null) {
//       groupIDCheck = 0;
//     } else {
//       groupIDCheck = groupID;
//     }

//     const PostQuery = {
//       userID: socialData && socialData.uid,
//       userCode: socialData && socialData.memtoken,
//       appID: socialData && socialData.aid,
//       companyID: socialData && socialData.cid,
//       postID: postID,
//       groupID: groupIDCheck,
//     };

//     httpClient
//       .post(
//         "api/social/posts_save.php",
//         qs.stringify({
//           action: "post_delete ",
//           source: PostQuery,
//         })
//       )
//       .then((res) => {
//         if (res.data.success !== "true") {
//           NotificationManager.warning(
//             "Sorry couldn't delete posts right now ! Please Refresh"
//           );
//           this.CancelDeletePost();
//         } else {
//           NotificationManager.success(res.data.msg);
//           this.CancelDeletePost();
//           this.props.DeleteWork(true);
//           setTimeout(() => {
//             history.push(`/app/social/profileDetail`);
//           }, 3000)
//         }
//       });
//   };

//   getSinglePost = () => {
//     this.setState({
//       showCarousel: true,
//     });
//     const getPostQuery = {
//       userID: socialData && socialData.uid,
//       userCode: socialData && socialData.memtoken,
//       appID: socialData && socialData.aid,
//       groupID: 0,
//       page: 0,
//       postedByUserID: socialData && socialData.uid,
//       companyID: socialData && socialData.cid,
//       postID: this.state.post.postID,
//       imageHeight: 600,
//       imageWidth: 600,
//     };

//     httpClient
//       .post(
//         "api/social/posts_get.php",
//         qs.stringify({
//           action: "posts_get",
//           source: getPostQuery,
//         })
//       )
//       .then((res) => {
//         if (res.data !== null) {
//           this.setState({
//             singleData:
//               res.data.data[0].images === "" ? "" : res.data.data[0].images,
//             single: true,
//             showCarousel: false,
//           });
//         }
//       });
//   };

//   handleSeeUser = (postedUserID, postedUserName) => {
//     history.push(
//       `/app/social/member/${postedUserID}/${postedUserName.replace(
//         /\s+/g,
//         "_"
//       )}`
//     );
//   };

//   handleSeeGroup(id, groupName) {
//     // history.push(`/app/social/group/${groupName.replace(/\s+/g, "_")}/${id}`);
//     this.setState({
//       groupID1: id,
//       groupName1: groupName,
//       openEtiquette: true,

//     });

//   }

//   handleEtiquetteClose = () => {
//     this.setState({
//       openEtiquette: false,

//     });
//   }

//   // onCommentImageChange = (e) => {
//   //   // console.log('e.taget >>>', e.target.files)
//   //   if (e.target.files.length > 8) {
//   //     e.preventDefault();
//   //     alert(`Cannot upload files more than 8`);

//   //     e.target.files = null;
//   //   } else {
//   //     // this.state.commentImage = [...e.target.files]
//   //     var comImg = [...e.target.files];
//   //     this.setState({
//   //       ...this.state,
//   //       commentImage: comImg,
//   //     });
//   //   }
//   //   //  console.log('commnet image', this.state.commentImage && this.state.commentImage);
//   // };
// onCommentImageChange = (e) => {
//   const allowedTypes = [
//     'image/jpeg',
//     'image/jpg', 
//     'image/png',
//     'image/gif'
//   ];
//   const maxFiles = 8;
//   const maxSize = 5 * 1024 * 1024; // 5MB in bytes

//   if (e.target.files.length > maxFiles) {
//     e.preventDefault();
//     NotificationManager.warning(`Cannot upload more than ${maxFiles} files`);
//     e.target.value = '';
//     return;
//   }

//   const filesArray = Array.from(e.target.files);
//   const invalidFiles = [];
//   const tooLargeFiles = [];

//   // Check each file (still needed for browsers that don't enforce accept)
//   filesArray.forEach(file => {
//     // Check file type
//     if (!allowedTypes.includes(file.type.toLowerCase())) {
//       invalidFiles.push(file.name);
//     }
    
//     // Check file size
//     if (file.size > maxSize) {
//       tooLargeFiles.push(file.name);
//     }
//   });

//   // Show validation errors
//   if (invalidFiles.length > 0) {
//     NotificationManager.error(
//       `Invalid file type(s): ${invalidFiles.join(', ')}. ` +
//       `Please select only JPEG, JPG, PNG, or GIF files.`
//     );
//     e.target.value = '';
//     return;
//   }

//   if (tooLargeFiles.length > 0) {
//     NotificationManager.warning(
//       `File(s) too large: ${tooLargeFiles.join(', ')}. ` +
//       `Maximum size is 5MB per file`
//     );
//     e.target.value = '';
//     return;
//   }

//   // All validations passed
//   this.setState({
//     ...this.state,
//     commentImage: filesArray,
//   });
// };
//   render() {
//     const {
//       postedUserName,
//       postedDate,
//       images,
//       // totalLikes,
//       totalComments,
//       groupID,
//       groupName,
//       postTitle,
//       postID,
//       userThumbnail,
//       postedUserID,
//       cntCommentCount,
//       commentImage,
//     } = this.state.post;

//     // console.log('props in post', this.props)
//     console.log('state for post edit', this.state.post);

//     // console.log("post data items >>>>>>>>>>", this.state);
//     // console.log('total comments >>', this.state.totalComments);
//     const postDate = moment(postedDate);
//     const currDate = moment();

//     let regex = "/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig";
//     let final = (postTitle);
//     let match = (postTitle).match(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);
//     // console.log('match', match);
//     // console.log('final', final);
//     let newURL;
//     match && match.map(url => {
//       newURL = url.split('//').pop().split('/')[0] + "..." + url.slice(url.length - 10);
//       final = final.replace(url, "<a href=\"" + url + "\" target=\"_BLANK\">" + (url.length > 60 ? newURL : url) + "</a>");
//     })

//     return (
//       <>
//         {this.state.deleteAlert && ( 
//           <AlertDialog
//             postID={postID}
//             groupID={groupID}
//             deleteAlert={this.state.deleteAlert}
//             CancelDeletePost={this.CancelDeletePost}
//             handleDeletePost={this.handleDeletePost}
//           />
//         )}
//         {this.state.openEtiquette && (
//           <GroupDetail
//             open={true}
//             handleEtiquetteClose={this.handleEtiquetteClose}
//             groupName={this.state.groupName1}
//             groupID={this.state.groupID1}
//             openEtiquette={this.state.openEtiquette}
//           />
//         )}
//         <Card className="jr-card">
//           <div className="jr-wall-content">
//             <div className="media jr-wall-user-info flex-nowrap align-items-center">
//               <Avatar
//                 src={userThumbnail}
//                 alt={postedUserName}
//                 className="mr-3 mb-2 size-50"
//               />
//               <div className="media-body">
//                 <p className="jr-wall-user-title">
//                   <span
//                     style={{ cursor: "pointer" }}
//                     onClick={() =>
//                       this.handleSeeUser(postedUserID, postedUserName)
//                     }
//                   >
//                     {postedUserName}{" "}
//                   </span>
//                   {groupName && (
//                     <span
//                       onClick={() => this.handleSeeGroup(groupID, groupName)}
//                       style={{ cursor: "pointer" }}
//                     >
//                       <PlayFill
//                         style={{
//                           fontSize: "16px",
//                           position: "relative",
//                           top: "3px",
//                         }}
//                       />{" "}
//                       {groupName}
//                     </span>
//                   )}
//                 </p>
//                 {/* <DisplayDate date={postedDate} /> */}
//                 <span
//                   style={{
//                     fontSize: "12px",
//                     fontWeight: "bold",
//                     color: "#ababab",
//                   }}
//                 >
//                   {moment(postedDate).format(socialData && socialData.timeFormat === 24 ? "MMMM Do YYYY, HH:mm" : "MMMM Do YYYY, h:mm a")}
//                 </span>
//               </div>

//               {this.state.userProfile && (
//                 <>
//                   <Tooltip title="Delete">
//                     <IconButton
//                       className="icon-btn text-light p-1"
//                       onClick={this.RequestDeletePost}
//                     >
//                       <DeleteIcon fontSize="small" />
//                       {/* <Trash /> */}
//                     </IconButton>
//                   </Tooltip>
//                   {/* {(postDate.to(currDate, true) === "5 minutes") && ( */}

//                   {/* {(currDate - postDate < 300000) && ( */}
//                   <Tooltip title="Edit">
//                     <IconButton
//                       onClick={this.RequestEditPostOpen}
//                       className="icon-btn text-light p-1"
//                     >
//                       <EditIcon fontSize="small" />
//                     </IconButton>
//                   </Tooltip>
//                   {/* )} */}

//                   <EditPostItem
//                     open={this.state.open}
//                     handleClose={this.RequestEditPostClose}
//                     editPost={this.editPost}
//                     post={this.state.post}
//                   />
//                 </>
//               )}
//             </div>
//             <div style={{ wordBreak: "break-word" }}>
//               <p style={{ fontSize: "16px" }}>


//                 {postTitle.substring(0, 5) === "https" ? (
//                   <a href={parse(postTitle)} target="_blank">
//                     {/* {parse(postTitle)} */}
//                     {postTitle.length > 60 ?
//                       postTitle.split('//').pop().split('/')[0] + "..." + postTitle.slice(postTitle.length - 10)
//                       : parse(postTitle)
//                     }
//                   </a>
//                 ) : (
//                   parse(final)
//                 )}
//               </p>
//             </div>
//             <div className="jr-wall-medialist">
//               {images && images.length >= 0 ? (
//                 <MediaList
//                   mediaList={
//                     this.state.single
//                       ? this.state.singleData
//                       : images === ""
//                         ? null
//                         : images
//                   }
//                   getSinglePost={this.getSinglePost}
//                   showCarousel={this.state.showCarousel}
//                 />
//               ) : null}
//             </div>
//             <div className="d-flex flex-row mb-2 mb-xl-3">
//               <p
//                 className="jr-fs-sm pointer mr-3 text-grey"
//                 onClick={this.handleLikeToggle.bind(this)}
//                 style={{
//                   pointerEvents: this.state.likeLoader ? "none" : "auto",
//                 }}
//               >
//                 {this.state.isLiked === "1" || this.state.isLiked === 1 ? (
//                   <i
//                     className="zmdi zmdi-favorite jr-fs-lg mr-2 d-inline-flex align-middle"
//                     style={{ color: "blue" }}
//                   />
//                 ) : (
//                   <i className="zmdi zmdi-favorite-outline jr-fs-lg mr-2 d-inline-flex align-middle" />
//                 )}
//                 <span className="d-inline-flex vertical-align-middle">
//                   {/* {this.state.totalLikes ? this.state.totalLikes + " Likes" : "Likes"} */}

//                   {this.state.totalLikes === undefined
//                     ? "0" + " " + "Likes"
//                     : this.state.totalLikes == "1"
//                       ? this.state.totalLikes + " " + "Like"
//                       : this.state.totalLikes + " " + "Likes"}
//                 </span>
//               </p>

//               <p
//                 className="jr-fs-sm pointer mr-3 text-blue"
//                 onClick={this.seeAllComments}
//               >
//                 <i className="zmdi zmdi-comment-more jr-fs-lg mr-2 d-inline-flex align-middle" />
//                 <span className="d-inline-flex align-middle">
//                   {this.state && this.state.totalComments > 0
//                     ? (this.state && this.state.totalComments) + " Comments"
//                     : "0 Comments"}
//                 </span>
//                 {cntCommentCount && cntCommentCount != 0 ? (
//                   <span
//                     style={{
//                       background:
//                         "linear-gradient(to bottom,  #dd1815 0%,#901419 100%)",
//                       boxShadow: "0 3px 6px rgb(0 0 0 / 24%)",
//                       borderRadius: "50%",
//                       height: "8px",
//                       width: "8px",
//                       display: "inline-block",
//                       marginLeft: "5px",
//                     }}
//                   ></span>
//                 ) : (
//                   ""
//                 )}
//               </p>

//               {/* <span className="text-primary jr-fs-md pointer d-block mb-4">
//               See All Comments{" "}
//               <i
//                 className={`zmdi zmdi-long-arrow-right jr-fs-xxl ml-2 d-inline-flex align-middle`}
//               />
//             </span> */}
//             </div>

//             <div className="jr-wall-comment-box">
//               {this.state.commentLoader && (
//                 <CircularProgress style={{ marginLeft: "40%" }} />
//               )}

//               {this.state.showComments &&
//                 this.state.commentList &&
//                 this.state.commentList.length > 0 &&
//                 this.state.commentList.map((commentData, index) => (
//                   <CommentBox
//                     key={commentData.commentID}
//                     index={index}
//                     commentData={commentData}
//                     deleteAlert={this.state.deleteAlert}
//                     filterDeletedComment={this.filterDeletedComment}
//                     handleSubComment={this.handleSubComment}
//                     showSubCommentsImage={true}
//                     handleCommentRemove={this.handleCommentRemove}
//                     getAllComments={this.getAllComments}
//                   />
//                 ))}
//             </div>

//             <div className="jr-wall-comment-box">
//               <div className="media mb-2">
//                 <Avatar
//                   className="mr-3 size-36"
//                   src={this.state.user.image}
//                   alt={this.state.user.name}
//                 />
//                 <div className="media-body">
//                   {/* <Input
//                     className="border-3"
//                     placeholder="Type Commentsss"
//                     type="textarea"
//                     id="required"
//                     value={this.state.message}
//                     onChange={(event) => this.updateCommentValue(event)}
//                     // onKeyPress={(event) => this.handleNewComment(event)}
//                   /> */}

//                   <ReactQuill
//                     placeholder="Type Comments"
//                     value={this.state.message}
//                     onChange={(value) => this.updateCommentValueEditor(value)}
//                     modules={{
//                       toolbar: [
//                         ['bold', 'italic', 'underline', 'strike'],
//                         [{ 'header': 1 }, { 'header': 2 }],
//                         [{ 'list': 'ordered' }, { 'list': 'bullet' }],
//                         ['link'],
//                         // ['image'],
//                         ['clean'],
//                       ],
//                     }}
//                     formats={[
//                       'header',
//                       'bold', 'italic', 'underline', 'strike',
//                       'link',
//                       // 'image',
//                       'list', 'bullet',
//                     ]}
//                   />

//                   {/* {featureServer && this.state.commentList &&
//                   <Box pt={1} pb={1}>
//                     {this.state.commentList.returnImage && this.state.commentList.returnImage.map(comImage => (
//                       <div>
//                       <img src={comImage.imageURL} style={{height: "100px", width:"100px" , margin:"5px"}} />
//                       </div>
//                     ))}
//                   </Box>
//                   } */}
//                   {/* {featureServer &&  */}
//                   <Box pt={1} pb={1}>
//                     <div className="boxarea">
//                       <label
//                         style={{ fontSize: "11px", marginRight: "10px" }}
//                         for="comment_image"
//                       >
//                         Select Image Files (Max 8):
//                       </label>
//                       <input
//                         type="file"
//                         onChange={this.onCommentImageChange}
//                         name="commentImage"
//                         id="comment_image"
//                         style={{ fontSize: "11px" }}
//                         multiple
//                         ref={this.commentImageRef}
//                          accept=".jpeg,.jpg,.png,.gif,image/jpeg,image/jpg,image/png,image/gif"
//                       />
//                     </div>
//                     <div className="boxarea">
//                       <span style={{ fontSize: "11px" }}>
//                         Note: Supported image format: .jpeg, .jpg, .png, .gif{" "}
//                       </span>
//                     </div>
//                   </Box>
//                   {/* } */}
//                   <Box textAlign="right" pt={1}>
//                     <Button
//                       disabled={
//                         this.state.message !== "" ||
//                           this.state.commentImage.length > 0
//                           ? this.state.commentPostLoader
//                             ? true
//                             : false
//                           : true
//                       }
//                       variant="contained"
//                       color="primary"
//                       size="small"
//                       style={{ fontSize: "10px", minWidth: "50px" }}
//                       onClick={(event) => this.handleNewComment(event)}
//                     >
//                       POST
//                       {/* <ArrowRightSquareFill style={{ color: "blue" }} /> */}
//                     </Button>
//                     {this.state.commentPostLoader && (
//                       <CircularProgress
//                         style={{
//                           marginLeft: "10px",
//                           position: "relative",
//                           top: "5px",
//                         }}
//                         size={20}
//                       />
//                     )}
//                   </Box>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </Card>
//         <NotificationContainer />
//       </>
//     );
//   }
// }

// export default PostItem;



// import React, { Component } from "react";
// import Avatar from "@material-ui/core/Avatar";
// import CommentBox from "./CommentBox";
// import MediaList from "./MediaList";
// import Button from "@material-ui/core/Button";
// import Card from "@material-ui/core/Card";
// import { Input } from "reactstrap";
// import { ArrowRightSquareFill, PlayFill, Trash } from "react-bootstrap-icons";
// import DeleteIcon from "@material-ui/icons/Delete";
// import EditIcon from "@material-ui/icons/Edit";
// import moment from "moment";
// import { history } from "../../../store/index";
// import { httpClient } from "appUtility/Api";
// import IconButton from "@material-ui/core/IconButton";
// import AlertDialog from "./AlertDialog";
// import {
//   NotificationManager,
//   NotificationContainer,
// } from "react-notifications";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import EditPostItem from "./EditPostItem";
// import CommentContext from "./CommentContext";
// import { Box, Tooltip, withStyles } from "@material-ui/core";
// import parse from "html-react-parser";
// import featureServer from "./../../../appUtility/featureServer";
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
// import GroupDetail from "../../../app/routes/socialApps/routes/Profile/groupDetail";

// const qs = require("qs");
// const socialData = JSON.parse(window.localStorage.getItem("login"));

// // Define styles for the component
// const styles = (theme) => ({
//   '@global': {
//     '@keyframes highlightPulse': {
//       '0%': {
//         transform: 'scale(1)',
//         backgroundColor: '#fff3cd',
//       },
//       '50%': {
//         transform: 'scale(1.02)',
//         backgroundColor: '#ffeaa7',
//       },
//       '100%': {
//         transform: 'scale(1)',
//         backgroundColor: '#fff3cd',
//       },
//     },
//     '@keyframes highlightFade': {
//       '0%': {
//         backgroundColor: '#fff3cd',
//         opacity: '1',
//       },
//       '70%': {
//         backgroundColor: '#fff3cd',
//         opacity: '0.8',
//       },
//       '100%': {
//         backgroundColor: 'transparent',
//         opacity: '1',
//       },
//     },
//     '.comment-highlight': {
//       backgroundColor: '#fff3cd !important',
//       transition: 'background-color 0.3s ease',
//       borderRadius: '4px',
//       animation: 'highlightPulse 0.5s ease-in-out, highlightFade 2s ease-in-out 0.5s forwards',
//     },
//   },
// });

// class PostItem extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       message: "",
//       totalComments: "",
//       totalLikes: "",
//       isLiked: null,
//       likeLoader: false,
//       deleteAlert: false,
//       user: {
//         name: socialData && socialData.fname + "" + socialData.lname,
//         userID: socialData && socialData.uid,
//         image: socialData && socialData.img,
//       },
//       post: {},
//       userProfile: "",
//       showComments: false,
//       commentList: [],
//       commentLoader: false,
//       commentPostLoader: false,
//       singleData: [],
//       single: false,
//       showCarousel: false,
//       open: false,
//       commentImage: [],
//       openEtiquette: false,
//       groupID1: "",
//       groupName1: "",
//       highlightCompleted: false, // Track if highlight has been done
//     };
//     this.commentImageRef = React.createRef();
//     this.highlightedCommentRef = React.createRef();
//     this.retryHighlightCount = 0;
//     this.maxRetries = 5;
//   }

//   componentWillMount() {
//     this.setState({
//       post: this.props.postData,
//       totalComments: this.props.postData.totalComments,
//       totalLikes: this.props.postData.totalLikes,
//       userProfile: this.props.userProfile,
//       isLiked: this.props.postData.isLiked,
//     });
//   }

//   componentDidMount() {
//     // Check if there's a comment to highlight
//     if (this.props.highlightedCommentId && !this.state.highlightCompleted) {
//       this.initiateHighlight();
//     }
//   }

//   componentDidUpdate(prevProps, prevState) {
//     // If highlightedCommentId changed and comments are now loaded
//     if (this.props.highlightedCommentId && 
//         this.props.highlightedCommentId !== prevProps.highlightedCommentId &&
//         !this.state.highlightCompleted) {
//       this.initiateHighlight();
//     }
    
//     // If comments just finished loading and we have a comment to highlight
//     if (this.props.highlightedCommentId && 
//         !this.state.highlightCompleted &&
//         this.state.commentList.length > 0 && 
//         prevState.commentList.length === 0) {
//       this.initiateHighlight();
//     }
//   }

//   initiateHighlight = () => {
//     // Reset retry counter
//     this.retryHighlightCount = 0;
    
//     // First, ensure comments are loaded
//     if (!this.state.showComments) {
//       this.seeAllComments();
//     }
    
//     // Try to highlight immediately, then retry if comment not found
//     setTimeout(() => {
//       this.scrollToAndHighlightComment(this.props.highlightedCommentId);
//     }, 500);
//   };

//   scrollToAndHighlightComment = (commentId) => {
//     // Find the comment element by ID
//     const commentElement = document.getElementById(`comment-${commentId}`);
    
//     if (commentElement) {
//       // Scroll to the comment smoothly
//       commentElement.scrollIntoView({ 
//         behavior: 'smooth', 
//         block: 'center' 
//       });
      
//       // Remove any existing highlight class first
//       commentElement.classList.remove('comment-highlight');
      
//       // Force a reflow to ensure animation plays
//       void commentElement.offsetWidth;
      
//       // Add highlight class
//       commentElement.classList.add('comment-highlight');
      
//       // Mark highlight as completed
//       this.setState({ highlightCompleted: true });
      
//       // Remove highlight class after 2 seconds (2000ms)
//       setTimeout(() => {
//         if (commentElement) {
//           commentElement.classList.remove('comment-highlight');
//         }
//       }, 2000);
//     } else if (this.retryHighlightCount < this.maxRetries) {
//       // If comment not found yet, retry after delay (comments might still be loading)
//       this.retryHighlightCount++;
//       console.log(`Comment ${commentId} not found, retry ${this.retryHighlightCount}/${this.maxRetries}`);
//       setTimeout(() => {
//         this.scrollToAndHighlightComment(commentId);
//       }, 500);
//     } else {
//       console.warn(`Comment ${commentId} not found after ${this.maxRetries} retries`);
//     }
//   };

//   filterDeletedComment = (id) => {
//     let filteredComment = this.state.commentList.filter(
//       (item) => item.commentID !== id
//     );
//     this.setState({ ...this.state, commentList: filteredComment });
//   };

//   RequestDeletePost = () => {
//     this.setState({ ...this.state, deleteAlert: true });
//   };

//   CancelDeletePost = () => {
//     this.setState({ ...this.state, deleteAlert: false });
//   };

//   handleNewComment = (e) => {
//     let comData = new FormData();
//     this.setState({
//       ...this.state,
//       commentLoader: true,
//       commentPostLoader: true,
//     });
//     comData.append("userID", socialData && socialData.uid);
//     comData.append("userCode", socialData && socialData.memtoken);
//     comData.append("appID", socialData && socialData.aid);
//     comData.append("companyID", socialData && socialData.cid);
//     comData.append("commentText", this.state.message);
//     comData.append("postID", this.state.post.postID);
//     this.state.commentImage.forEach((img) =>
//       comData.append("mediaList[]", img)
//     );
//     comData.append("action", "comments_save");
//     comData.append("imageHeight", 600);
//     comData.append("imageWidth", 600);

//     httpClient
//       .post("api/social/posts_comments_save.php", comData)
//       .then((res) => {
//         if (res.data.msg !== "Commented Successfully") {
//           this.setState({
//             ...this.state,
//             commentLoader: false,
//             commentPostLoader: false,
//           });
//           NotificationManager.warning(res.data.msg);
//           this.getAllComments();
//         } else {
//           NotificationManager.success(res.data.msg);
//           this.setState({
//             ...this.state,
//             message: "",
//             totalComments: res.data.totalComments,
//             commentPostLoader: false,
//           });

//           if (!this.state.showComments) {
//             this.setState({ ...this.state, showComments: true });
//           }
//           let latestComment = {
//             commentUserName:
//               socialData && socialData.fname + "" + socialData.lname,
//             commentText: res && res.data && res.data.commenttext,
//             commentID: res && res.data && res.data.commentID.toString(),
//             postID: res && res.data && res.data.postID,
//             commentUserID: res && res.data && res.data.userID,
//             commentedDate: moment(),
//             totalComments: "0",
//             userThumbnail: res && res.data && res.data.userThumbnail,
//           };

//           if (this.state.commentList.length === 0) {
//             this.getAllComments();
//           } else {
//             let updatedCommentList = this.state.commentList.concat([
//               latestComment,
//             ]);
//             this.setState({
//               ...this.state,
//               commentList: updatedCommentList,
//               commentLoader: false,
//               commentPostLoader: false,
//               totalComments: res && res.data && res.data.totalComments,
//             });
//             this.getAllComments();
//           }
//           this.setState({ commentImage: [] });
//           if (this.commentImageRef.current) {
//             this.commentImageRef.current.value = "";
//           }
//         }
//       });
//   };

//   handleCommentRemove = (commentID, postID) => {
//     const deleteQuery = {
//       userID: socialData && socialData.uid,
//       userCode: socialData && socialData.memtoken,
//       appID: socialData && socialData.aid,
//       companyID: socialData && socialData.cid,
//       postID: postID,
//       commentID: commentID,
//       parentCommentID: 0,
//     };

//     httpClient
//       .post(
//         "api/social/posts_comments_save.php",
//         qs.stringify({
//           action: "comments_delete",
//           source: deleteQuery,
//         })
//       )
//       .then((res) => {
//         if (res.data.success !== "true") {
//           NotificationManager.warning(res.data.msg);
//         } else {
//           NotificationManager.success(res.data.msg);
//           this.setState({
//             totalComments: res.data && res.data.totalComments,
//           });
//           this.filterDeletedComment(res.data.commentID);
//         }
//       });
//   };

//   updateCommentValue(evt) {
//     this.setState({ ...this.state, message: evt.target.value });
//   }

//   updateCommentValueEditor(value) {
//     this.setState({ ...this.state, message: value });
//   }

//   handleLikeToggle() {
//     this.setState({
//       likeLoader: true,
//     });
//     if (
//       this.state.isLiked === "0" ||
//       this.state.isLiked === 0 ||
//       this.state.isLiked === undefined
//     ) {
//       const likeData = {
//         userID: socialData && socialData.uid,
//         userCode: socialData && socialData.memtoken,
//         appID: socialData && socialData.aid,
//         companyID: socialData && socialData.cid,
//         postID: this.state.post.postID,
//       };

//       httpClient
//         .post(
//           "api/social/likes_save.php",
//           qs.stringify({
//             action: "likes_save",
//             source: likeData,
//           })
//         )
//         .then((res) => {
//           if (res.data.success === "true") {
//             this.setState({
//               ...this.state,
//               totalLikes: res.data.total++,
//               isLiked: 1,
//               likeLoader: false,
//             });
//           } else {
//             NotificationManager.warning(res.data.msg);
//           }
//         });
//     } else {
//       const likeData = {
//         userID: socialData && socialData.uid,
//         userCode: socialData && socialData.memtoken,
//         appID: socialData && socialData.aid,
//         companyID: socialData && socialData.cid,
//         postID: this.state.post.postID,
//       };

//       httpClient
//         .post(
//           "api/social/likes_save.php",
//           qs.stringify({
//             action: "likes_remove",
//             source: likeData,
//           })
//         )
//         .then((res) => {
//           if (res.data.success === "true") {
//             this.setState({
//               ...this.state,
//               totalLikes: res.data.total--,
//               isLiked: 0,
//               likeLoader: false,
//             });
//           } else {
//             NotificationManager.warning(res.data.msg);
//           }
//         });
//     }
//   }

//   getAllComments = (total) => {
//     this.setState({
//       ...this.state,
//       showComments: true,
//       commentList: [],
//       commentLoader: true,
//     });

//     const getCommentsQuery = {
//       userID: socialData && socialData.uid,
//       userCode: socialData && socialData.memtoken,
//       appID: socialData && socialData.aid,
//       companyID: socialData && socialData.cid,
//       postID: this.state.post.postID,
//     };

//     httpClient
//       .post(
//         "api/social/posts_comments_get.php",
//         qs.stringify({
//           action: "posts_comments",
//           source: getCommentsQuery,
//         })
//       )
//       .then((res) => {
//         if (res.data.data === null) {
//           console.log("No comments for this post !");
//           this.setState({ ...this.state, commentLoader: false });
//         } else {
//           total !== undefined
//             ? this.setState({
//                 ...this.state,
//                 commentList: res.data.data,
//                 commentLoader: false,
//                 totalComments: total,
//                 showComments: true,
//               })
//             : this.setState({
//                 ...this.state,
//                 commentList: res.data.data,
//                 commentLoader: false,
//               });
//         }
//       });
//   };

//   seeAllComments = () => {
//     if (this.state.commentList.length > 0) {
//       this.setState({ ...this.state, showComments: !this.state.showComments });
//     } else if (this.props.postData.totalComments === "0") {
//       this.setState({ ...this.state, showComments: !this.state.showComments });
//     } else if (this.props.postData.totalComments !== "0") {
//       this.getAllComments();
//     } else {
//       return;
//     }
//   };

//   RequestEditPostOpen = () => {
//     this.setState({
//       open: true,
//     });
//   };

//   RequestEditPostClose = (callback) => {
//     this.setState({
//       open: false,
//     });
//   };

//   editPost = (postTitle, imageList) => {
//     let fd = new FormData();
//     fd.append("userID", socialData && socialData.uid);
//     fd.append("userCode", socialData && socialData.memtoken);
//     fd.append("appID", socialData && socialData.aid);
//     fd.append("companyID", socialData && socialData.cid);
//     fd.append("postText", postTitle);
//     fd.append("postID", this.state.post.postID);
//     fd.append("groupID", this.state.post.groupID != null ? this.state.post.groupID : 0);
//     fd.append("type", "post_save");
//     fd.append("imageHeight", 600);
//     fd.append("imageWidth", 600);

//     httpClient.post("api/social/posts_save.php", fd).then((res) => {
//       if (res.data.success === "false") {
//         NotificationManager.warning(res.data.msg);
//       } else {
//         NotificationManager.success(res.data.msg);
//         this.RequestEditPostClose();
//         setTimeout(() => {
//           history.push(`/app/social/profileDetail`);
//         }, 3000);
//       }
//     });
//   };

//   handleDeletePost = (postID, groupID) => {
//     let groupIDCheck;

//     if (groupID === null) {
//       groupIDCheck = 0;
//     } else {
//       groupIDCheck = groupID;
//     }

//     const PostQuery = {
//       userID: socialData && socialData.uid,
//       userCode: socialData && socialData.memtoken,
//       appID: socialData && socialData.aid,
//       companyID: socialData && socialData.cid,
//       postID: postID,
//       groupID: groupIDCheck,
//     };

//     httpClient
//       .post(
//         "api/social/posts_save.php",
//         qs.stringify({
//           action: "post_delete ",
//           source: PostQuery,
//         })
//       )
//       .then((res) => {
//         if (res.data.success !== "true") {
//           NotificationManager.warning(
//             "Sorry couldn't delete posts right now ! Please Refresh"
//           );
//           this.CancelDeletePost();
//         } else {
//           NotificationManager.success(res.data.msg);
//           this.CancelDeletePost();
//           this.props.DeleteWork(true);
//           setTimeout(() => {
//             history.push(`/app/social/profileDetail`);
//           }, 3000);
//         }
//       });
//   };

//   getSinglePost = () => {
//     this.setState({
//       showCarousel: true,
//     });
//     const getPostQuery = {
//       userID: socialData && socialData.uid,
//       userCode: socialData && socialData.memtoken,
//       appID: socialData && socialData.aid,
//       groupID: 0,
//       page: 0,
//       postedByUserID: socialData && socialData.uid,
//       companyID: socialData && socialData.cid,
//       postID: this.state.post.postID,
//       imageHeight: 600,
//       imageWidth: 600,
//     };

//     httpClient
//       .post(
//         "api/social/posts_get.php",
//         qs.stringify({
//           action: "posts_get",
//           source: getPostQuery,
//         })
//       )
//       .then((res) => {
//         if (res.data !== null) {
//           this.setState({
//             singleData:
//               res.data.data[0].images === "" ? "" : res.data.data[0].images,
//             single: true,
//             showCarousel: false,
//           });
//         }
//       });
//   };

//   handleSeeUser = (postedUserID, postedUserName) => {
//     history.push(
//       `/app/social/member/${postedUserID}/${postedUserName.replace(
//         /\s+/g,
//         "_"
//       )}`
//     );
//   };

//   handleSeeGroup(id, groupName) {
//     this.setState({
//       groupID1: id,
//       groupName1: groupName,
//       openEtiquette: true,
//     });
//   }

//   handleEtiquetteClose = () => {
//     this.setState({
//       openEtiquette: false,
//     });
//   };

//   onCommentImageChange = (e) => {
//     const allowedTypes = [
//       'image/jpeg',
//       'image/jpg',
//       'image/png',
//       'image/gif'
//     ];
//     const maxFiles = 8;
//     const maxSize = 5 * 1024 * 1024;

//     if (e.target.files.length > maxFiles) {
//       e.preventDefault();
//       NotificationManager.warning(`Cannot upload more than ${maxFiles} files`);
//       e.target.value = '';
//       return;
//     }

//     const filesArray = Array.from(e.target.files);
//     const invalidFiles = [];
//     const tooLargeFiles = [];

//     filesArray.forEach(file => {
//       if (!allowedTypes.includes(file.type.toLowerCase())) {
//         invalidFiles.push(file.name);
//       }
//       if (file.size > maxSize) {
//         tooLargeFiles.push(file.name);
//       }
//     });

//     if (invalidFiles.length > 0) {
//       NotificationManager.error(
//         `Invalid file type(s): ${invalidFiles.join(', ')}. ` +
//         `Please select only JPEG, JPG, PNG, or GIF files.`
//       );
//       e.target.value = '';
//       return;
//     }

//     if (tooLargeFiles.length > 0) {
//       NotificationManager.warning(
//         `File(s) too large: ${tooLargeFiles.join(', ')}. ` +
//         `Maximum size is 5MB per file`
//       );
//       e.target.value = '';
//       return;
//     }

//     this.setState({
//       ...this.state,
//       commentImage: filesArray,
//     });
//   };

//   render() {
//     const {
//       postedUserName,
//       postedDate,
//       images,
//       totalComments,
//       groupID,
//       groupName,
//       postTitle,
//       postID,
//       userThumbnail,
//       postedUserID,
//       cntCommentCount,
//       commentImage,
//     } = this.state.post;

//     const postDate = moment(postedDate);
//     const currDate = moment();

//     let regex = "/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig";
//     let final = (postTitle);
//     let match = (postTitle).match(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);
//     let newURL;
//     match && match.map(url => {
//       newURL = url.split('//').pop().split('/')[0] + "..." + url.slice(url.length - 10);
//       final = final.replace(url, "<a href=\"" + url + "\" target=\"_BLANK\">" + (url.length > 60 ? newURL : url) + "</a>");
//     });

//     return (
//       <>
//         {this.state.deleteAlert && (
//           <AlertDialog
//             postID={postID}
//             groupID={groupID}
//             deleteAlert={this.state.deleteAlert}
//             CancelDeletePost={this.CancelDeletePost}
//             handleDeletePost={this.handleDeletePost}
//           />
//         )}
//         {this.state.openEtiquette && (
//           <GroupDetail
//             open={true}
//             handleEtiquetteClose={this.handleEtiquetteClose}
//             groupName={this.state.groupName1}
//             groupID={this.state.groupID1}
//             openEtiquette={this.state.openEtiquette}
//           />
//         )}
//         <Card className="jr-card">
//           <div className="jr-wall-content">
//             <div className="media jr-wall-user-info flex-nowrap align-items-center">
//               <Avatar
//                 src={userThumbnail}
//                 alt={postedUserName}
//                 className="mr-3 mb-2 size-50"
//               />
//               <div className="media-body">
//                 <p className="jr-wall-user-title">
//                   <span
//                     style={{ cursor: "pointer" }}
//                     onClick={() =>
//                       this.handleSeeUser(postedUserID, postedUserName)
//                     }
//                   >
//                     {postedUserName}{" "}
//                   </span>
//                   {groupName && (
//                     <span
//                       onClick={() => this.handleSeeGroup(groupID, groupName)}
//                       style={{ cursor: "pointer" }}
//                     >
//                       <PlayFill
//                         style={{
//                           fontSize: "16px",
//                           position: "relative",
//                           top: "3px",
//                         }}
//                       />{" "}
//                       {groupName}
//                     </span>
//                   )}
//                 </p>
//                 <span
//                   style={{
//                     fontSize: "12px",
//                     fontWeight: "bold",
//                     color: "#ababab",
//                   }}
//                 >
//                   {moment(postedDate).format(socialData && socialData.timeFormat === 24 ? "MMMM Do YYYY, HH:mm" : "MMMM Do YYYY, h:mm a")}
//                 </span>
//               </div>

//               {this.state.userProfile && (
//                 <>
//                   <Tooltip title="Delete">
//                     <IconButton
//                       className="icon-btn text-light p-1"
//                       onClick={this.RequestDeletePost}
//                     >
//                       <DeleteIcon fontSize="small" />
//                     </IconButton>
//                   </Tooltip>
//                   <Tooltip title="Edit">
//                     <IconButton
//                       onClick={this.RequestEditPostOpen}
//                       className="icon-btn text-light p-1"
//                     >
//                       <EditIcon fontSize="small" />
//                     </IconButton>
//                   </Tooltip>

//                   <EditPostItem
//                     open={this.state.open}
//                     handleClose={this.RequestEditPostClose}
//                     editPost={this.editPost}
//                     post={this.state.post}
//                   />
//                 </>
//               )}
//             </div>
//             <div style={{ wordBreak: "break-word" }}>
//               <p style={{ fontSize: "16px" }}>
//                 {postTitle.substring(0, 5) === "https" ? (
//                   <a href={parse(postTitle)} target="_blank" rel="noopener noreferrer">
//                     {postTitle.length > 60
//                       ? postTitle.split('//').pop().split('/')[0] + "..." + postTitle.slice(postTitle.length - 10)
//                       : parse(postTitle)
//                     }
//                   </a>
//                 ) : (
//                   parse(final)
//                 )}
//               </p>
//             </div>
//             <div className="jr-wall-medialist">
//               {images && images.length >= 0 ? (
//                 <MediaList
//                   mediaList={
//                     this.state.single
//                       ? this.state.singleData
//                       : images === ""
//                         ? null
//                         : images
//                   }
//                   getSinglePost={this.getSinglePost}
//                   showCarousel={this.state.showCarousel}
//                 />
//               ) : null}
//             </div>
//             <div className="d-flex flex-row mb-2 mb-xl-3">
//               <p
//                 className="jr-fs-sm pointer mr-3 text-grey"
//                 onClick={this.handleLikeToggle.bind(this)}
//                 style={{
//                   pointerEvents: this.state.likeLoader ? "none" : "auto",
//                 }}
//               >
//                 {this.state.isLiked === "1" || this.state.isLiked === 1 ? (
//                   <i
//                     className="zmdi zmdi-favorite jr-fs-lg mr-2 d-inline-flex align-middle"
//                     style={{ color: "blue" }}
//                   />
//                 ) : (
//                   <i className="zmdi zmdi-favorite-outline jr-fs-lg mr-2 d-inline-flex align-middle" />
//                 )}
//                 <span className="d-inline-flex vertical-align-middle">
//                   {this.state.totalLikes === undefined
//                     ? "0" + " " + "Likes"
//                     : this.state.totalLikes == "1"
//                       ? this.state.totalLikes + " " + "Like"
//                       : this.state.totalLikes + " " + "Likes"}
//                 </span>
//               </p>

//               <p
//                 className="jr-fs-sm pointer mr-3 text-blue"
//                 onClick={this.seeAllComments}
//               >
//                 <i className="zmdi zmdi-comment-more jr-fs-lg mr-2 d-inline-flex align-middle" />
//                 <span className="d-inline-flex align-middle">
//                   {this.state && this.state.totalComments > 0
//                     ? (this.state && this.state.totalComments) + " Comments"
//                     : "0 Comments"}
//                 </span>
//                 {cntCommentCount && cntCommentCount != 0 ? (
//                   <span
//                     style={{
//                       background:
//                         "linear-gradient(to bottom,  #dd1815 0%,#901419 100%)",
//                       boxShadow: "0 3px 6px rgb(0 0 0 / 24%)",
//                       borderRadius: "50%",
//                       height: "8px",
//                       width: "8px",
//                       display: "inline-block",
//                       marginLeft: "5px",
//                     }}
//                   ></span>
//                 ) : (
//                   ""
//                 )}
//               </p>
//             </div>

//             <div className="jr-wall-comment-box">
//               {this.state.commentLoader && (
//                 <CircularProgress style={{ marginLeft: "40%" }} />
//               )}

//               {this.state.showComments &&
//                 this.state.commentList &&
//                 this.state.commentList.length > 0 &&
//                 this.state.commentList.map((commentData, index) => (
//                   <div id={`comment-${commentData.commentID}`} key={commentData.commentID}>
//                     <CommentBox
//                       index={index}
//                       commentData={commentData}
//                       deleteAlert={this.state.deleteAlert}
//                       filterDeletedComment={this.filterDeletedComment}
//                       handleSubComment={this.handleSubComment}
//                       showSubCommentsImage={true}
//                       handleCommentRemove={this.handleCommentRemove}
//                       getAllComments={this.getAllComments}
//                     />
//                   </div>
//                 ))}
//             </div>

//             <div className="jr-wall-comment-box">
//               <div className="media mb-2">
//                 <Avatar
//                   className="mr-3 size-36"
//                   src={this.state.user.image}
//                   alt={this.state.user.name}
//                 />
//                 <div className="media-body">
//                   <ReactQuill
//                     placeholder="Type Comments"
//                     value={this.state.message}
//                     onChange={(value) => this.updateCommentValueEditor(value)}
//                     modules={{
//                       toolbar: [
//                         ['bold', 'italic', 'underline', 'strike'],
//                         [{ 'header': 1 }, { 'header': 2 }],
//                         [{ 'list': 'ordered' }, { 'list': 'bullet' }],
//                         ['link'],
//                         ['clean'],
//                       ],
//                     }}
//                     formats={[
//                       'header',
//                       'bold', 'italic', 'underline', 'strike',
//                       'link',
//                       'list', 'bullet',
//                     ]}
//                   />

//                   <Box pt={1} pb={1}>
//                     <div className="boxarea">
//                       <label
//                         style={{ fontSize: "11px", marginRight: "10px" }}
//                         htmlFor="comment_image"
//                       >
//                         Select Image Files (Max 8):
//                       </label>
//                       <input
//                         type="file"
//                         onChange={this.onCommentImageChange}
//                         name="commentImage"
//                         id="comment_image"
//                         style={{ fontSize: "11px" }}
//                         multiple
//                         ref={this.commentImageRef}
//                         accept=".jpeg,.jpg,.png,.gif,image/jpeg,image/jpg,image/png,image/gif"
//                       />
//                     </div>
//                     <div className="boxarea">
//                       <span style={{ fontSize: "11px" }}>
//                         Note: Supported image format: .jpeg, .jpg, .png, .gif{" "}
//                       </span>
//                     </div>
//                   </Box>
//                   <Box textAlign="right" pt={1}>
//                     <Button
//                       disabled={
//                         this.state.message !== "" ||
//                         this.state.commentImage.length > 0
//                           ? this.state.commentPostLoader
//                             ? true
//                             : false
//                           : true
//                       }
//                       variant="contained"
//                       color="primary"
//                       size="small"
//                       style={{ fontSize: "10px", minWidth: "50px" }}
//                       onClick={(event) => this.handleNewComment(event)}
//                     >
//                       POST
//                     </Button>
//                     {this.state.commentPostLoader && (
//                       <CircularProgress
//                         style={{
//                           marginLeft: "10px",
//                           position: "relative",
//                           top: "5px",
//                         }}
//                         size={20}
//                       />
//                     )}
//                   </Box>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </Card>
//         <NotificationContainer />
//       </>
//     );
//   }
// }

// export default withStyles(styles)(PostItem);


// **************************************************************************************************************************************

import React, { Component } from "react";
import Avatar from "@material-ui/core/Avatar";
import CommentBox from "./CommentBox";
import MediaList from "./MediaList";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import { Input } from "reactstrap";
import { ArrowRightSquareFill, PlayFill, Trash } from "react-bootstrap-icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import moment from "moment";
import { history } from "../../../store/index";
import { httpClient } from "appUtility/Api";
import IconButton from "@material-ui/core/IconButton";
import AlertDialog from "./AlertDialog";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import CircularProgress from "@material-ui/core/CircularProgress";
import EditPostItem from "./EditPostItem";
import CommentContext from "./CommentContext";
import { Box, Tooltip, withStyles } from "@material-ui/core";
import parse from "html-react-parser";
import featureServer from "./../../../appUtility/featureServer";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import GroupDetail from "../../../app/routes/socialApps/routes/Profile/groupDetail";

const qs = require("qs");
const socialData = JSON.parse(window.localStorage.getItem("login"));

// Define styles for the component
const styles = (theme) => ({
  '@global': {
    '@keyframes highlightPulse': {
      '0%': {
        transform: 'scale(1)',
        backgroundColor: '#fff3cd',
      },
      '50%': {
        transform: 'scale(1.02)',
        backgroundColor: '#ffeaa7',
      },
      '100%': {
        transform: 'scale(1)',
        backgroundColor: '#fff3cd',
      },
    },
    '@keyframes highlightFade': {
      '0%': {
        backgroundColor: '#fff3cd',
        opacity: '1',
      },
      '70%': {
        backgroundColor: '#fff3cd',
        opacity: '0.8',
      },
      '100%': {
        backgroundColor: 'transparent',
        opacity: '1',
      },
    },
    '.comment-highlight': {
      backgroundColor: '#fff3cd !important',
      transition: 'background-color 0.3s ease',
      borderRadius: '4px',
      animation: 'highlightPulse 0.5s ease-in-out, highlightFade 2s ease-in-out 0.5s forwards',
    },
    '@keyframes likePop': {
      '0%': {
        transform: 'scale(1)',
      },
      '50%': {
        transform: 'scale(1.3)',
      },
      '100%': {
        transform: 'scale(1)',
      },
    },
    '.like-animation': {
      animation: 'likePop 0.3s ease-in-out',
    },
  },
});

class PostItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      totalComments: "",
      totalLikes: "",
      isLiked: null,
      likeLoader: false,
      isProcessingLike: false, // Add this for debouncing
      deleteAlert: false,
      user: {
        name: socialData && socialData.fname + "" + socialData.lname,
        userID: socialData && socialData.uid,
        image: socialData && socialData.img,
      },
      post: {},
      userProfile: "",
      showComments: false,
      commentList: [],
      commentLoader: false,
      commentPostLoader: false,
      singleData: [],
      single: false,
      showCarousel: false,
      open: false,
      commentImage: [],
      openEtiquette: false,
      groupID1: "",
      groupName1: "",
      highlightCompleted: false, // Track if highlight has been done
    };
    this.commentImageRef = React.createRef();
    this.highlightedCommentRef = React.createRef();
    this.retryHighlightCount = 0;
    this.maxRetries = 5;
    this.likeTimeout = null;
  }

  componentWillMount() {
    this.setState({
      post: this.props.postData,
      totalComments: this.props.postData.totalComments,
      totalLikes: this.props.postData.totalLikes,
      userProfile: this.props.userProfile,
      isLiked: this.props.postData.isLiked,
    });
  }

  componentDidMount() {
    // Check if there's a comment to highlight
    if (this.props.highlightedCommentId && !this.state.highlightCompleted) {
      this.initiateHighlight();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // If highlightedCommentId changed and comments are now loaded
    if (this.props.highlightedCommentId && 
        this.props.highlightedCommentId !== prevProps.highlightedCommentId &&
        !this.state.highlightCompleted) {
      this.initiateHighlight();
    }
    
    // If comments just finished loading and we have a comment to highlight
    if (this.props.highlightedCommentId && 
        !this.state.highlightCompleted &&
        this.state.commentList.length > 0 && 
        prevState.commentList.length === 0) {
      this.initiateHighlight();
    }
  }

  initiateHighlight = () => {
    // Reset retry counter
    this.retryHighlightCount = 0;
    
    // First, ensure comments are loaded
    if (!this.state.showComments) {
      this.seeAllComments();
    }
    
    // Try to highlight immediately, then retry if comment not found
    setTimeout(() => {
      this.scrollToAndHighlightComment(this.props.highlightedCommentId);
    }, 500);
  };

  scrollToAndHighlightComment = (commentId) => {
    // Find the comment element by ID
    const commentElement = document.getElementById(`comment-${commentId}`);
    
    if (commentElement) {
      // Scroll to the comment smoothly
      commentElement.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      
      // Remove any existing highlight class first
      commentElement.classList.remove('comment-highlight');
      
      // Force a reflow to ensure animation plays
      void commentElement.offsetWidth;
      
      // Add highlight class
      commentElement.classList.add('comment-highlight');
      
      // Mark highlight as completed
      this.setState({ highlightCompleted: true });
      
      // Remove highlight class after 2 seconds (2000ms)
      setTimeout(() => {
        if (commentElement) {
          commentElement.classList.remove('comment-highlight');
        }
      }, 2000);
    } else if (this.retryHighlightCount < this.maxRetries) {
      // If comment not found yet, retry after delay (comments might still be loading)
      this.retryHighlightCount++;
      console.log(`Comment ${commentId} not found, retry ${this.retryHighlightCount}/${this.maxRetries}`);
      setTimeout(() => {
        this.scrollToAndHighlightComment(commentId);
      }, 500);
    } else {
      console.warn(`Comment ${commentId} not found after ${this.maxRetries} retries`);
    }
  };

  filterDeletedComment = (id) => {
    let filteredComment = this.state.commentList.filter(
      (item) => item.commentID !== id
    );
    this.setState({ ...this.state, commentList: filteredComment });
  };

  RequestDeletePost = () => {
    this.setState({ ...this.state, deleteAlert: true });
  };

  CancelDeletePost = () => {
    this.setState({ ...this.state, deleteAlert: false });
  };

  handleNewComment = (e) => {
    let comData = new FormData();
    this.setState({
      ...this.state,
      commentLoader: true,
      commentPostLoader: true,
    });
    comData.append("userID", socialData && socialData.uid);
    comData.append("userCode", socialData && socialData.memtoken);
    comData.append("appID", socialData && socialData.aid);
    comData.append("companyID", socialData && socialData.cid);
    comData.append("commentText", this.state.message);
    comData.append("postID", this.state.post.postID);
    this.state.commentImage.forEach((img) =>
      comData.append("mediaList[]", img)
    );
    comData.append("action", "comments_save");
    comData.append("imageHeight", 600);
    comData.append("imageWidth", 600);

    httpClient
      .post("api/social/posts_comments_save.php", comData)
      .then((res) => {
        if (res.data.msg !== "Commented Successfully") {
          this.setState({
            ...this.state,
            commentLoader: false,
            commentPostLoader: false,
          });
          NotificationManager.warning(res.data.msg);
          this.getAllComments();
        } else {
          NotificationManager.success(res.data.msg);
          this.setState({
            ...this.state,
            message: "",
            totalComments: res.data.totalComments,
            commentPostLoader: false,
          });

          if (!this.state.showComments) {
            this.setState({ ...this.state, showComments: true });
          }
          let latestComment = {
            commentUserName:
              socialData && socialData.fname + "" + socialData.lname,
            commentText: res && res.data && res.data.commenttext,
            commentID: res && res.data && res.data.commentID.toString(),
            postID: res && res.data && res.data.postID,
            commentUserID: res && res.data && res.data.userID,
            commentedDate: moment(),
            totalComments: "0",
            userThumbnail: res && res.data && res.data.userThumbnail,
          };

          if (this.state.commentList.length === 0) {
            this.getAllComments();
          } else {
            let updatedCommentList = this.state.commentList.concat([
              latestComment,
            ]);
            this.setState({
              ...this.state,
              commentList: updatedCommentList,
              commentLoader: false,
              commentPostLoader: false,
              totalComments: res && res.data && res.data.totalComments,
            });
            this.getAllComments();
          }
          this.setState({ commentImage: [] });
          if (this.commentImageRef.current) {
            this.commentImageRef.current.value = "";
          }
        }
      });
  };

  handleCommentRemove = (commentID, postID) => {
    const deleteQuery = {
      userID: socialData && socialData.uid,
      userCode: socialData && socialData.memtoken,
      appID: socialData && socialData.aid,
      companyID: socialData && socialData.cid,
      postID: postID,
      commentID: commentID,
      parentCommentID: 0,
    };

    httpClient
      .post(
        "api/social/posts_comments_save.php",
        qs.stringify({
          action: "comments_delete",
          source: deleteQuery,
        })
      )
      .then((res) => {
        if (res.data.success !== "true") {
          NotificationManager.warning(res.data.msg);
        } else {
          NotificationManager.success(res.data.msg);
          this.setState({
            totalComments: res.data && res.data.totalComments,
          });
          this.filterDeletedComment(res.data.commentID);
        }
      });
  };

  updateCommentValue(evt) {
    this.setState({ ...this.state, message: evt.target.value });
  }

  updateCommentValueEditor(value) {
    this.setState({ ...this.state, message: value });
  }

  // OPTIMIZED LIKE HANDLER WITH OPTIMISTIC UPDATES
  handleLikeToggle() {
    // Prevent multiple rapid clicks
    if (this.state.isProcessingLike) {
      return;
    }
    
    // Add haptic feedback for mobile (instant tactile response)
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate(50); // 50ms vibration
    }
    
    this.setState({ isProcessingLike: true });
    
    // Store previous state for potential rollback
    const previousLikedState = this.state.isLiked;
    const previousLikesCount = this.state.totalLikes;
    
    // 1. OPTIMISTIC UPDATE - Update UI immediately
    const newLikedState = (previousLikedState === "1" || previousLikedState === 1) ? 0 : 1;
    const newLikesCount = newLikedState === 1 
      ? (parseInt(previousLikesCount) + 1).toString()
      : (parseInt(previousLikesCount) - 1).toString();
    
    // Instant UI update (this happens in milliseconds)
    this.setState({
      isLiked: newLikedState,
      totalLikes: newLikesCount,
    });
    
    // Add animation class to like button
    const likeButton = document.getElementById(`like-button-${this.state.post.postID}`);
    if (likeButton) {
      likeButton.classList.add('like-animation');
      setTimeout(() => {
        if (likeButton) {
          likeButton.classList.remove('like-animation');
        }
      }, 300);
    }
    
    // 2. BACKGROUND API CALL
    const likeData = {
      userID: socialData && socialData.uid,
      userCode: socialData && socialData.memtoken,
      appID: socialData && socialData.aid,
      companyID: socialData && socialData.cid,
      postID: this.state.post.postID,
    };
    
    const isCurrentlyLiked = (previousLikedState === "1" || previousLikedState === 1);
    const action = isCurrentlyLiked ? "likes_remove" : "likes_save";
    
    httpClient
      .post(
        "api/social/likes_save.php",
        qs.stringify({
          action: action,
          source: likeData,
        })
      )
      .then((res) => {
        if (res.data.success === "true") {
          // Success - keep the optimistic state, just update with actual server count if needed
          this.setState({
            totalLikes: res.data.total, // Use server's count to ensure accuracy
          });
        } else {
          // Failed - rollback to previous state
          this.setState({
            isLiked: previousLikedState,
            totalLikes: previousLikesCount,
          });
          NotificationManager.warning(res.data.msg || "Failed to update like");
        }
      })
      .catch((error) => {
        // Error - rollback to previous state
        this.setState({
          isLiked: previousLikedState,
          totalLikes: previousLikesCount,
        });
        NotificationManager.error("Network error. Please try again.");
      })
      .finally(() => {
        // Re-enable after 500ms to prevent spam
        setTimeout(() => {
          this.setState({ isProcessingLike: false });
        }, 500);
      });
  }

  getAllComments = (total) => {
    this.setState({
      ...this.state,
      showComments: true,
      commentList: [],
      commentLoader: true,
    });

    const getCommentsQuery = {
      userID: socialData && socialData.uid,
      userCode: socialData && socialData.memtoken,
      appID: socialData && socialData.aid,
      companyID: socialData && socialData.cid,
      postID: this.state.post.postID,
    };

    httpClient
      .post(
        "api/social/posts_comments_get.php",
        qs.stringify({
          action: "posts_comments",
          source: getCommentsQuery,
        })
      )
      .then((res) => {
        if (res.data.data === null) {
          console.log("No comments for this post !");
          this.setState({ ...this.state, commentLoader: false });
        } else {
          total !== undefined
            ? this.setState({
                ...this.state,
                commentList: res.data.data,
                commentLoader: false,
                totalComments: total,
                showComments: true,
              })
            : this.setState({
                ...this.state,
                commentList: res.data.data,
                commentLoader: false,
              });
        }
      });
  };

  seeAllComments = () => {
    if (this.state.commentList.length > 0) {
      this.setState({ ...this.state, showComments: !this.state.showComments });
    } else if (this.props.postData.totalComments === "0") {
      this.setState({ ...this.state, showComments: !this.state.showComments });
    } else if (this.props.postData.totalComments !== "0") {
      this.getAllComments();
    } else {
      return;
    }
  };

  RequestEditPostOpen = () => {
    this.setState({
      open: true,
    });
  };

  RequestEditPostClose = (callback) => {
    this.setState({
      open: false,
    });
  };

  editPost = (postTitle, imageList) => {
    let fd = new FormData();
    fd.append("userID", socialData && socialData.uid);
    fd.append("userCode", socialData && socialData.memtoken);
    fd.append("appID", socialData && socialData.aid);
    fd.append("companyID", socialData && socialData.cid);
    fd.append("postText", postTitle);
    fd.append("postID", this.state.post.postID);
    fd.append("groupID", this.state.post.groupID != null ? this.state.post.groupID : 0);
    fd.append("type", "post_save");
    fd.append("imageHeight", 600);
    fd.append("imageWidth", 600);

    httpClient.post("api/social/posts_save.php", fd).then((res) => {
      if (res.data.success === "false") {
        NotificationManager.warning(res.data.msg);
      } else {
        NotificationManager.success(res.data.msg);
        this.RequestEditPostClose();
        setTimeout(() => {
          history.push(`/app/social/profileDetail`);
        }, 3000);
      }
    });
  };

  handleDeletePost = (postID, groupID) => {
    let groupIDCheck;

    if (groupID === null) {
      groupIDCheck = 0;
    } else {
      groupIDCheck = groupID;
    }

    const PostQuery = {
      userID: socialData && socialData.uid,
      userCode: socialData && socialData.memtoken,
      appID: socialData && socialData.aid,
      companyID: socialData && socialData.cid,
      postID: postID,
      groupID: groupIDCheck,
    };

    httpClient
      .post(
        "api/social/posts_save.php",
        qs.stringify({
          action: "post_delete ",
          source: PostQuery,
        })
      )
      .then((res) => {
        if (res.data.success !== "true") {
          NotificationManager.warning(
            "Sorry couldn't delete posts right now ! Please Refresh"
          );
          this.CancelDeletePost();
        } else {
          NotificationManager.success(res.data.msg);
          this.CancelDeletePost();
          this.props.DeleteWork(true);
          setTimeout(() => {
            history.push(`/app/social/profileDetail`);
          }, 3000);
        }
      });
  };

  getSinglePost = () => {
    this.setState({
      showCarousel: true,
    });
    const getPostQuery = {
      userID: socialData && socialData.uid,
      userCode: socialData && socialData.memtoken,
      appID: socialData && socialData.aid,
      groupID: 0,
      page: 0,
      postedByUserID: socialData && socialData.uid,
      companyID: socialData && socialData.cid,
      postID: this.state.post.postID,
      imageHeight: 600,
      imageWidth: 600,
    };

    httpClient
      .post(
        "api/social/posts_get.php",
        qs.stringify({
          action: "posts_get",
          source: getPostQuery,
        })
      )
      .then((res) => {
        if (res.data !== null) {
          this.setState({
            singleData:
              res.data.data[0].images === "" ? "" : res.data.data[0].images,
            single: true,
            showCarousel: false,
          });
        }
      });
  };

  handleSeeUser = (postedUserID, postedUserName) => {
    history.push(
      `/app/social/member/${postedUserID}/${postedUserName.replace(
        /\s+/g,
        "_"
      )}`
    );
  };

  handleSeeGroup(id, groupName) {
    this.setState({
      groupID1: id,
      groupName1: groupName,
      openEtiquette: true,
    });
  }

  handleEtiquetteClose = () => {
    this.setState({
      openEtiquette: false,
    });
  };

  onCommentImageChange = (e) => {
    const allowedTypes = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif'
    ];
    const maxFiles = 8;
    const maxSize = 5 * 1024 * 1024;

    if (e.target.files.length > maxFiles) {
      e.preventDefault();
      NotificationManager.warning(`Cannot upload more than ${maxFiles} files`);
      e.target.value = '';
      return;
    }

    const filesArray = Array.from(e.target.files);
    const invalidFiles = [];
    const tooLargeFiles = [];

    filesArray.forEach(file => {
      if (!allowedTypes.includes(file.type.toLowerCase())) {
        invalidFiles.push(file.name);
      }
      if (file.size > maxSize) {
        tooLargeFiles.push(file.name);
      }
    });

    if (invalidFiles.length > 0) {
      NotificationManager.error(
        `Invalid file type(s): ${invalidFiles.join(', ')}. ` +
        `Please select only JPEG, JPG, PNG, or GIF files.`
      );
      e.target.value = '';
      return;
    }

    if (tooLargeFiles.length > 0) {
      NotificationManager.warning(
        `File(s) too large: ${tooLargeFiles.join(', ')}. ` +
        `Maximum size is 5MB per file`
      );
      e.target.value = '';
      return;
    }

    this.setState({
      ...this.state,
      commentImage: filesArray,
    });
  };

  render() {
    const {
      postedUserName,
      postedDate,
      images,
      totalComments,
      groupID,
      groupName,
      postTitle,
      postID,
      userThumbnail,
      postedUserID,
      cntCommentCount,
      commentImage,
    } = this.state.post;

    const postDate = moment(postedDate);
    const currDate = moment();

    let regex = "/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig";
    let final = (postTitle);
    let match = (postTitle).match(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);
    let newURL;
    match && match.map(url => {
      newURL = url.split('//').pop().split('/')[0] + "..." + url.slice(url.length - 10);
      final = final.replace(url, "<a href=\"" + url + "\" target=\"_BLANK\">" + (url.length > 60 ? newURL : url) + "</a>");
    });

    return (
      <>
        {this.state.deleteAlert && (
          <AlertDialog
            postID={postID}
            groupID={groupID}
            deleteAlert={this.state.deleteAlert}
            CancelDeletePost={this.CancelDeletePost}
            handleDeletePost={this.handleDeletePost}
          />
        )}
        {this.state.openEtiquette && (
          <GroupDetail
            open={true}
            handleEtiquetteClose={this.handleEtiquetteClose}
            groupName={this.state.groupName1}
            groupID={this.state.groupID1}
            openEtiquette={this.state.openEtiquette}
          />
        )}
        <Card className="jr-card">
          <div className="jr-wall-content">
            <div className="media jr-wall-user-info flex-nowrap align-items-center">
              <Avatar
                src={userThumbnail}
                alt={postedUserName}
                className="mr-3 mb-2 size-50"
              />
              <div className="media-body">
                <p className="jr-wall-user-title">
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.handleSeeUser(postedUserID, postedUserName)
                    }
                  >
                    {postedUserName}{" "}
                  </span>
                  {groupName && (
                    <span
                      onClick={() => this.handleSeeGroup(groupID, groupName)}
                      style={{ cursor: "pointer" }}
                    >
                      <PlayFill
                        style={{
                          fontSize: "16px",
                          position: "relative",
                          top: "3px",
                        }}
                      />{" "}
                      {groupName}
                    </span>
                  )}
                </p>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#ababab",
                  }}
                >
                  {moment(postedDate).format(socialData && socialData.timeFormat === 24 ? "MMMM Do YYYY, HH:mm" : "MMMM Do YYYY, h:mm a")}
                </span>
              </div>

              {this.state.userProfile && (
                <>
                  <Tooltip title="Delete">
                    <IconButton
                      className="icon-btn text-light p-1"
                      onClick={this.RequestDeletePost}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Edit">
                    <IconButton
                      onClick={this.RequestEditPostOpen}
                      className="icon-btn text-light p-1"
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <EditPostItem
                    open={this.state.open}
                    handleClose={this.RequestEditPostClose}
                    editPost={this.editPost}
                    post={this.state.post}
                  />
                </>
              )}
            </div>
            <div style={{ wordBreak: "break-word" }}>
              <p style={{ fontSize: "16px" }}>
                {postTitle.substring(0, 5) === "https" ? (
                  <a href={parse(postTitle)} target="_blank" rel="noopener noreferrer">
                    {postTitle.length > 60
                      ? postTitle.split('//').pop().split('/')[0] + "..." + postTitle.slice(postTitle.length - 10)
                      : parse(postTitle)
                    }
                  </a>
                ) : (
                  parse(final)
                )}
              </p>
            </div>
            <div className="jr-wall-medialist">
              {images && images.length >= 0 ? (
                <MediaList
                  mediaList={
                    this.state.single
                      ? this.state.singleData
                      : images === ""
                        ? null
                        : images
                  }
                  getSinglePost={this.getSinglePost}
                  showCarousel={this.state.showCarousel}
                />
              ) : null}
            </div>
            <div className="d-flex flex-row mb-2 mb-xl-3">
              <p
                id={`like-button-${postID}`}
                className="jr-fs-sm pointer mr-3 text-grey"
                onClick={this.handleLikeToggle.bind(this)}
                style={{
                  pointerEvents: this.state.isProcessingLike ? "none" : "auto",
                  transition: 'transform 0.1s ease',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center'
                }}
                onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.95)'}
                onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                {this.state.isLiked === "1" || this.state.isLiked === 1 ? (
                  <i
                    className="zmdi zmdi-favorite jr-fs-lg mr-2 d-inline-flex align-middle"
                    style={{ color: "blue", transition: 'all 0.1s ease' }}
                  />
                ) : (
                  <i className="zmdi zmdi-favorite-outline jr-fs-lg mr-2 d-inline-flex align-middle" />
                )}
                <span className="d-inline-flex vertical-align-middle">
                  {this.state.totalLikes === undefined
                    ? "0 Likes"
                    : this.state.totalLikes == "1"
                      ? this.state.totalLikes + " Like"
                      : this.state.totalLikes + " Likes"}
                </span>
              </p>

              <p
                className="jr-fs-sm pointer mr-3 text-blue"
                onClick={this.seeAllComments}
              >
                <i className="zmdi zmdi-comment-more jr-fs-lg mr-2 d-inline-flex align-middle" />
                <span className="d-inline-flex align-middle">
                  {this.state && this.state.totalComments > 0
                    ? (this.state && this.state.totalComments) + " Comments"
                    : "0 Comments"}
                </span>
                {cntCommentCount && cntCommentCount != 0 ? (
                  <span
                    style={{
                      background:
                        "linear-gradient(to bottom,  #dd1815 0%,#901419 100%)",
                      boxShadow: "0 3px 6px rgb(0 0 0 / 24%)",
                      borderRadius: "50%",
                      height: "8px",
                      width: "8px",
                      display: "inline-block",
                      marginLeft: "5px",
                    }}
                  ></span>
                ) : (
                  ""
                )}
              </p>
            </div>

            <div className="jr-wall-comment-box">
              {this.state.commentLoader && (
                <CircularProgress style={{ marginLeft: "40%" }} />
              )}

              {this.state.showComments &&
                this.state.commentList &&
                this.state.commentList.length > 0 &&
                this.state.commentList.map((commentData, index) => (
                  <div id={`comment-${commentData.commentID}`} key={commentData.commentID}>
                    <CommentBox
                      index={index}
                      commentData={commentData}
                      deleteAlert={this.state.deleteAlert}
                      filterDeletedComment={this.filterDeletedComment}
                      handleSubComment={this.handleSubComment}
                      showSubCommentsImage={true}
                      handleCommentRemove={this.handleCommentRemove}
                      getAllComments={this.getAllComments}
                    />
                  </div>
                ))}
            </div>

            <div className="jr-wall-comment-box">
              <div className="media mb-2">
                <Avatar
                  className="mr-3 size-36"
                  src={this.state.user.image}
                  alt={this.state.user.name}
                />
                <div className="media-body">
                  <ReactQuill
                    placeholder="Type Comments"
                    value={this.state.message}
                    onChange={(value) => this.updateCommentValueEditor(value)}
                    modules={{
                      toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ 'header': 1 }, { 'header': 2 }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        ['link'],
                        ['clean'],
                      ],
                    }}
                    formats={[
                      'header',
                      'bold', 'italic', 'underline', 'strike',
                      'link',
                      'list', 'bullet',
                    ]}
                  />

                  <Box pt={1} pb={1}>
                    <div className="boxarea">
                      <label
                        style={{ fontSize: "11px", marginRight: "10px" }}
                        htmlFor="comment_image"
                      >
                        Select Image Files (Max 8):
                      </label>
                      <input
                        type="file"
                        onChange={this.onCommentImageChange}
                        name="commentImage"
                        id="comment_image"
                        style={{ fontSize: "11px" }}
                        multiple
                        ref={this.commentImageRef}
                        accept=".jpeg,.jpg,.png,.gif,image/jpeg,image/jpg,image/png,image/gif"
                      />
                    </div>
                    <div className="boxarea">
                      <span style={{ fontSize: "11px" }}>
                        Note: Supported image format: .jpeg, .jpg, .png, .gif{" "}
                      </span>
                    </div>
                  </Box>
                  <Box textAlign="right" pt={1}>
                    <Button
                      disabled={
                        this.state.message !== "" ||
                        this.state.commentImage.length > 0
                          ? this.state.commentPostLoader
                            ? true
                            : false
                          : true
                      }
                      variant="contained"
                      color="primary"
                      size="small"
                      style={{ fontSize: "10px", minWidth: "50px" }}
                      onClick={(event) => this.handleNewComment(event)}
                    >
                      POST
                    </Button>
                    {this.state.commentPostLoader && (
                      <CircularProgress
                        style={{
                          marginLeft: "10px",
                          position: "relative",
                          top: "5px",
                        }}
                        size={20}
                      />
                    )}
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </Card>
        <NotificationContainer />
      </>
    );
  }
}

export default withStyles(styles)(PostItem);